// The file is built by the bff (docs/shape-ops-report-export.md §3 D5); this only saves it.
export function downloadCsv(filename: string, file: Blob): void {
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
